module.exports = __webpack_public_path__ + "static/media/nancy.a260e50f.jpeg";